import { FormikProps, FormikValues, useFormikContext } from 'formik';

const useStudentsFormKey = (): string => {
  const { values }: FormikProps<FormikValues> = useFormikContext();
  const fieldKey = values?.students ? 'students' : 'ADD_STUDENTS.students';

  return fieldKey;
};

export default useStudentsFormKey;
